import React from 'react'
import PropTypes from 'prop-types'
import { Hr, Margin, Panel, Text, Table } from 'shared/components'

import { TeamFilters } from './components/filters'

const TeamOverviewComponent = ({
  columns,
  loadTeams,
  getTrProps,
  onSearch,
}) => (
  <Panel>
    <Margin tb={3}>
      <Text size={20} bold>
        Teams
      </Text>
    </Margin>
    <Hr width="full" />
    <Margin tb={3}>
      <TeamFilters debounce={250} onSearch={onSearch} />
    </Margin>
    <Table
      id="teams-table"
      columns={columns}
      loadData={loadTeams}
      getTrProps={getTrProps}
    />
  </Panel>
)

TeamOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadTeams: PropTypes.func.isRequired,
  getTrProps: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default TeamOverviewComponent
